import MuiLink, {LinkProps} from '@mui/material/Link';
import * as React from 'react'
import {Link as ReactLink, LinkProps as ReactLinkProps} from "react-router-dom";

export default function Link(props: LinkProps & ReactLinkProps) {
  return (<MuiLink {...props} component={ReactLink} />)

}
